/** Hair colors appended to FLUX style prompts (prompt-only studio). */

export const PROMPT_HAIR_COLORS = [
  { id: 'natural', name: 'Guest / natural', hex: null, prompt: '' },
  { id: 'black', name: 'Black', hex: '#1a1a1a', prompt: 'black' },
  { id: 'dark_brown', name: 'Dark brown', hex: '#3d2914', prompt: 'dark brown' },
  { id: 'brown', name: 'Brown', hex: '#5c4033', prompt: 'brown' },
  { id: 'light_brown', name: 'Light brown', hex: '#8b6914', prompt: 'light brown' },
  { id: 'burgundy', name: 'Burgundy', hex: '#722f37', prompt: 'burgundy' },
  { id: 'auburn', name: 'Auburn', hex: '#922724', prompt: 'auburn' },
  { id: 'copper', name: 'Copper', hex: '#b87333', prompt: 'copper red' },
  { id: 'blonde', name: 'Blonde', hex: '#d4b896', prompt: 'blonde' },
  { id: 'platinum', name: 'Platinum blonde', hex: '#e8e4dc', prompt: 'platinum blonde' },
  { id: 'caramel', name: 'Caramel', hex: '#c68e59', prompt: 'caramel' },
  { id: 'chocolate', name: 'Chocolate', hex: '#4a2c2a', prompt: 'chocolate brown' },
];

/** Map Gemma hair_color_name / hex to nearest prompt swatch (optional auto-pick). */
export function matchPromptHairColorFromProfile(profile) {
  if (!profile) return null;
  const name = String(profile.hair_color_name || '').toLowerCase();
  if (!name) return null;
  const byKeyword = [
    ['platinum', 'platinum'],
    ['blonde', 'blonde'],
    ['burgundy', 'burgundy'],
    ['auburn', 'auburn'],
    ['copper', 'copper'],
    ['caramel', 'caramel'],
    ['chocolate', 'chocolate'],
    ['light brown', 'light_brown'],
    ['dark brown', 'dark_brown'],
    ['brown', 'brown'],
    ['black', 'black'],
  ];
  for (const [needle, id] of byKeyword) {
    if (name.includes(needle)) {
      return PROMPT_HAIR_COLORS.find((c) => c.id === id) || null;
    }
  }
  return null;
}

export function buildPromptWithHairColor(basePrompt, colorEntry) {
  const base = String(basePrompt || '').trim();
  if (!base) return '';
  const entry = colorEntry || PROMPT_HAIR_COLORS[0];
  const tone = String(entry.prompt || '').trim();
  if (!tone || entry.id === 'natural') {
    return `${base}. Keep the guest's natural hair color.`;
  }
  return `${base}. Hair color: ${tone} hair, full length and roots, natural salon dye, realistic tone.`;
}
